import {createSelectorCreator, defaultMemoize} from 'reselect';
import {shallowEqual} from 'react-redux';
import {IElement} from '../../incase-domain/elements';
import {AppState} from '../reducer';

export const createSelectorWithShallowEqualResult = createSelectorCreator(defaultMemoize, {
    resultEqualityCheck: shallowEqual,
});

export function omit<T extends object, K extends keyof T>(obj: T, keys: ReadonlyArray<K>): Omit<T, K> {
    const result = {...obj};
    keys.forEach((key) => {
        delete result[key];
    });
    return result;
}

export function highlightedElementAtIndex(state: AppState): IElement | undefined {
    const slide = state.slideReducer.present.selectedSlide;
    const idx = state.slideReducer.present.highlightedElementIndex;
    const els = slide.elements ?? [];
    if (idx < 0 || idx >= els.length) {
        return undefined;
    }
    return els[idx];
}
